import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { DepartmentEntity } from "./department.entity";
import { DepartmentController } from "./department.controller";
import { DepartmentService } from "./department.service";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";


@Module({
    imports: [
        TypeOrmModule.forFeature([DepartmentEntity]),
    ],
    controllers: [DepartmentController],
    providers: [DepartmentService, ApplicationExceptionHandler]
})
export class DepartmentModule {

}